/**
 * @desc waiveFulfilment
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.outPlanFacadeImpl.waiveFulfilment.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/outPlan/waiveFulfilment`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
